/* External */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  profiles: [] || null,
  selectedProfile: null,
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    addProfile(state, { payload }) {
      return { ...state, profiles: payload };
    },
    editProfile(state, { payload }) {
      return { ...state, profiles: payload };
    },
    deleteProfile(state, { payload }) {
      return { ...state, profiles: payload };
    },
    setProfiles(state, { payload }) {
      return { ...state, profiles: payload?.data || payload };
    },
    setSelectedProfile(state, { payload }) {
      const newState = state;
      newState.selectedProfile = payload;
    },
  },
});

export const {
  addProfile,
  editProfile,
  deleteProfile,
  setProfiles,
  setSelectedProfile,
} = profileSlice.actions;

export default profileSlice.reducer;
